<script setup>
import { computed, defineEmits, reactive, shallowRef } from "vue"
import { email, minLength, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { writeToSupport } from "@/store/user/serverInterationMethods";
import { errorHandler } from "@/lib/errorHandler";
import { targetActionsMap } from "@/lib/sendYmParams";

const emit = defineEmits(['close']);

const isSending = shallowRef(false);


const state = reactive({
  name: '',
  email: '',
  question: '',
});


const rules = {
  name: { required, minLength: minLength(2) },
  email: { required, email },
  question: { required },
}


const validator = useVuelidate(rules, state);

const disabledSendButton = computed(
  () => validator.value.$errors.length || validator.value.$invalid || isSending.value
)

const onSubmit = async () => {
  targetActionsMap.get(27)();
  try {
    isSending.value = true;
    const formData = new FormData();
    Object.entries(state)
      .forEach(([key, value]) => formData.append(key, value));
    const { status, data: { message } } = await writeToSupport(formData);
    const name = status === 201 ? 'supportFormSuccess' : 'supportFormError';

    errorHandler({ name, message })

    validator.value.$reset();
    emit('close');
  } catch (error) {
    console.log(error);
  } finally {
    isSending.value = false;
  }
}

function onClose() {
  targetActionsMap.get(28)();
  emit('close');
}
</script>

<template>
  <div class="shell" @click="emit('close')">
    <div class="modal" @click.stop>
      <div class="modal-caption">
        <p class="title">Поддержка</p>
        <button class="close" @click="onClose">
        </button>
      </div>
      <div class="content">
        <div class="grid-2">
          <div class="field">
            <p class="field__text">Имя</p>
            <input v-model="validator.name.$model" :disabled="isSending" type="text" class="field__input">
          </div>
          <div class="field">
            <p class="field__text">Адрес электронной почты</p>
            <input type="text" v-model="validator.email.$model" :disabled="isSending" class="field__input">
          </div>
        </div>
        <div class="field">
          <p class="field__text">Ваш вопрос</p>
          <textarea v-model="validator.question.$model" :disabled="isSending"
            class="field__input field__input--textarea"></textarea>
        </div>
        <div class="end">
          <label class="check-wrapper" v-if="false">
            <span class="check">
              <input type="checkbox" v-model="validator.agreement.$model" class="check__input">
              <span class="check__box"></span>
            </span>
            <span class="check__text check__text--desk">Я даю согласие <br> на обработку <a href="/metamsk-politic.pdf"
                target="_blank">персональных данных</a></span>
            <span class="check__text check__text--mob">Я даю согласие на обработку <a href="/metamsk-politic.pdf"
                target="_blank">персональных данных</a></span>
          </label>
          <button class="link" :disabled="disabledSendButton" @click="onSubmit">Отправить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.grid-2 {
  @media (max-width: 1100px) {
    flex-direction: column;
  }
}

.field {
  max-width: 100%;
  width: 100%;
  gap: 1.25rem;

  &__text {
    font-weight: 500;
    font-size: 1rem;
    line-height: 125%;
    color: #13151a;
  }

  &__input {
    margin-top: 0.5rem;
    background: #fff;
    border: none;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 1.25rem;

    &--textarea {
      min-height: 10.25rem;
    }
  }
}

.end {
  display: flex;
  align-items: center;
  gap: 1.25rem;

  .link {
    max-width: 100%;
    width: 100%;
    justify-content: center;
    font-size: 1rem;
    padding: 0.88rem 1.25rem;
  }

  .link:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 1100px) {
    flex-direction: column;
  }
}

.check {
  display: flex;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  cursor: pointer;

  &-wrapper {
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1.375rem;
  }

  &:hover {
    opacity: 0.8;
  }

  &__input {
    position: absolute;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 0;

    &:checked+.check__box {
      background: center / cover no-repeat url("@/assets/new-icons/check__box-on.svg");
    }
  }

  &__text {
    max-width: 100%;
    width: 100%;
    font-size: 0.88rem;
    line-height: 130%;
    color: #13151a;

    a {
      color: #00288C;
    }

    &--mob {
      display: none;
    }
  }

  &__box {
    width: 100%;
    height: 100%;
    background: center / cover no-repeat url("@/assets/new-icons/check__box.svg");
  }


  @media (max-width: 1100px) {
    width: 1.5rem;
    height: 1.5rem;

    &-wrapper {
      max-width: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    &__text {
      &--mob {
        display: inline;
      }

      &--desk {
        display: none;
      }
    }
  }
}
</style>